var _linearGradient, _path, _linearGradient2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "_0oMkmiyGC8y4yxT1~122a",
    x1: -237.546,
    x2: -254.628,
    y1: -228.546,
    y2: -245.628,
    gradientTransform: "matrix(0 1 1 0 272 272)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#199ae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#1898de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#1691d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#1186cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#0a75bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076cb3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#_0oMkmiyGC8y4yxT1~122a)",
    d: "M25.401,9.58L44.42,28.599c0.774,0.774,0.774,2.028,0,2.802l-4.019,4.019 c-0.774,0.774-2.028,0.774-2.802,0L18.58,16.401c-0.774-0.774-0.774-2.028,0-2.802l4.019-4.019 C23.373,8.807,24.627,8.807,25.401,9.58z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "_0oMkmiyGC8y4yxT1~122b",
    x1: -260.281,
    x2: -238.285,
    y1: -244.719,
    y2: -266.715,
    gradientTransform: "matrix(0 1 1 0 272 272)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#_0oMkmiyGC8y4yxT1~122b)",
    d: "M29.42,16.401L10.401,35.42c-0.774,0.774-2.028,0.774-2.802,0L3.58,31.401 c-0.774-0.774-0.774-2.028,0-2.802L22.599,9.58c0.774-0.774,2.028-0.774,2.802,0l4.019,4.019 C30.193,14.373,30.193,15.627,29.42,16.401z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseArrow);
export default __webpack_public_path__ + "static/media/CollapseArrow.2c9e30453a9fca54423eb691fb9d9b9e.svg";
export { ForwardRef as ReactComponent };